import { useState } from 'react';
import './AdminPage.css';
import AccountManagement from './AccountManagement';
import AircraftManagement from './AircraftManagement';
import VertiportManagement from './VertiportManagement';
import FixAirwayManagement from './FixAirwayManagement';
import FlightPlanManagement from './FlightPlanManagement';

const MENU = [
  { id: 'account',    label: '계정 관리' },
  { id: 'aircraft',   label: '기체 관리' },
  { id: 'vertiport',  label: '버티포트 관리' },
  { id: 'route',      label: '노선 관리' },
  { id: 'flightplan', label: '비행 계획' },
];

export default function AdminPage({ session, onLogout, onBack, onHome }) {
  const [activeMenu, setActiveMenu] = useState('account');

  return (
    <div className="ap">
      {/* ── Header ── */}
      <header className="ap-header">
        <div className="ap-header-l">
          <img
            src="/logo-typo.png"
            alt="MIN-SOFT"
            className="ap-logo"
            onClick={onHome}
          />
          <span className="ap-divider" />
          <span className="ap-title">관리자 페이지</span>
        </div>
        <div className="ap-header-r">
          <button className="btn-back" onClick={onBack}>← 대시보드</button>
          <span className="ap-user">{session?.userName} [{session?.userId}]</span>
          <button className="btn-logout" onClick={onLogout}>로그아웃</button>
        </div>
      </header>

      <div className="ap-body">
        {/* ── Sidebar ── */}
        <nav className="ap-sidebar">
          <div className="ap-sidebar-section">MANAGEMENT</div>
          <ul className="ap-menu">
            {MENU.map(item => (
              <li key={item.id}>
                <button
                  className={`ap-menu-item${activeMenu === item.id ? ' active' : ''}`}
                  onClick={() => setActiveMenu(item.id)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* ── Content ── */}
        <main className="ap-content">
          {activeMenu === 'account' && (
            <div className="ap-content-inner">
              <div className="ap-content-hd">
                <span className="ap-content-title">계정 관리</span>
              </div>
              <AccountManagement />
            </div>
          )}
          {activeMenu === 'aircraft' && (
            <div className="ap-content-inner">
              <div className="ap-content-hd">
                <span className="ap-content-title">기체 관리</span>
              </div>
              <AircraftManagement />
            </div>
          )}
          {activeMenu === 'vertiport' && (
            <div className="ap-content-inner">
              <div className="ap-content-hd">
                <span className="ap-content-title">버티포트 관리</span>
              </div>
              <VertiportManagement />
            </div>
          )}
          {activeMenu === 'route' && (
            <div className="ap-content-inner">
              <div className="ap-content-hd">
                <span className="ap-content-title">노선 관리</span>
              </div>
              <FixAirwayManagement />
            </div>
          )}
          {activeMenu === 'flightplan' && (
            <div className="ap-content-inner">
              <div className="ap-content-hd">
                <span className="ap-content-title">비행 계획</span>
              </div>
              <FlightPlanManagement />
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
